import React, { Component } from 'react';
import { Row, Col, Card, Input, Button } from 'antd';
import Cookies from 'js-cookie';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import CooperationStatesSelect, { CooperationStates } from '../../components/public/CooperationStatesSelect';
import ConsultantTable from './ConsultantTable';
import './page-consultant.less';

interface ConsultantPageState {
    nameInputValue: string;
    expertiseInputValue: string;
    statesSelectValue: number | null;
}

class ConsultantPage extends Component<any, ConsultantPageState> {
    state: ConsultantPageState = {
        nameInputValue: '',
        expertiseInputValue: '',
        statesSelectValue: CooperationStates.normal,
    };

    consultantTableRef: ConsultantTable;

    componentDidMount(): void {
        if (this.consultantTableRef) {
            this.consultantTableRef.getConsultantTableData(1,
                this.state.nameInputValue,
                this.state.expertiseInputValue,
                this.state.statesSelectValue
            );
        }
    }

    handleQueryButtonClick = async () => {
        if (this.consultantTableRef) {
            await this.consultantTableRef.getConsultantTableData(1,
                this.state.nameInputValue,
                this.state.expertiseInputValue,
                this.state.statesSelectValue
            );
            this.consultantTableRef.setPaginationPage(1);
        }
    };

    handleAddButtonClick = () => {
        window.location.href = '/#/app/consultant/manager';
    };

    canEditConsultant = () => {
        const role = parseInt(Cookies.get('userRole') || '0', 10);
        const roleParts = new Set<number>();
        let remain = role;
        [1000, 100, 10, 2, 1].forEach((part) => {
            if (remain >= part) {
                remain -= part;
                roleParts.add(part);
            }
        });
        if (remain !== 0) {
            roleParts.clear();
            roleParts.add(role);
        }
        return roleParts.has(1) || roleParts.has(100) || roleParts.has(1000);
    };

    render() {
        return (
            <div className="gutter-consultant_container">
                <BreadcrumbCustom breads={['顾问管理', '顾问列表']} />
                <Row gutter={5}>
                    <Col md={23}>
                        <Card title="顾问列表" bordered={false}>
                            <div style={{ marginBottom: 16 }}>
                                <label className="label-consultant_name">姓名：</label>
                                <Input
                                    placeholder="按姓名查询"
                                    className="input-consultant_name"
                                    value={this.state.nameInputValue}
                                    onChange={(e) => this.setState({ nameInputValue: e.target.value })}
                                    allowClear
                                />

                                <label className="label-consultant_expertise">擅长领域：</label>
                                <Input
                                    placeholder="按关键能力查询"
                                    className="input-consultant_expertise"
                                    value={this.state.expertiseInputValue}
                                    onChange={(e) => this.setState({ expertiseInputValue: e.target.value })}
                                    allowClear
                                />

                                <label className="label-consultant_state">状态：</label>
                                <CooperationStatesSelect
                                    initialValues={CooperationStates.normal}
                                    onChange={(value) => this.setState({ statesSelectValue: value })}
                                />

                                <Button className="button-consultant_query" type="primary" onClick={this.handleQueryButtonClick}>
                                    查询
                                </Button>

                                {this.canEditConsultant() && (
                                    <Button className="button-consultant_add" type="primary" onClick={this.handleAddButtonClick}>
                                        新建顾问
                                    </Button>
                                )}
                            </div>

                            <ConsultantTable ref={(ref) => (this.consultantTableRef = ref)} />
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ConsultantPage;
